import _ from "lodash";
import CryptoJS from "crypto-js";
import { appConfig } from "config/initializers/config.app";
import { licenseMap } from "config/initializers/config.licenses";

/*
 * Actions
 */
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SESSION = "SESSION";
export const FORGOTPASSW = "FORGOTPASSW";
export const OMNIAUTHLOGIN = "OMNIAUTHLOGIN";
export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const GET_LICENSE = "GET_LICENSE";
export const ACCEPT_COOKIES = "ACCEPT_COOKIES";
export const UPDATE_USER_LICENSE = "UPDATE_USER_LICENSE";
export const INITIAL_PASSWORD_UPDATE = "INITIAL_PASSWORD_UPDATE";
export const REGISTER = "REGISTER";
export const UPDATE_END_DATE = "UPDATE_END_DATE";
export const UPDATE_SSO = "UPDATE_SSO";
export const ASIGN_COUPON = "ASIGN_COUPON";

/*
 * Action Creators
 */

function _login(status, err, data) {
    return {
        type: LOGIN,
        status,
        err,
        data,
    };
}

function _logout(status, err, data) {
    return {
        type: LOGOUT,
        status,
        err,
        data,
    };
}

function _session(status, err, data) {
    return {
        type: SESSION,
        status,
        err,
        data,
    };
}

function _omniauthLogin(status, err, data) {
    return {
        type: OMNIAUTHLOGIN,
        status,
        err,
        data,
    };
}
function _updateConfig(status, err, data) {
    return {
        type: UPDATE_CONFIG,
        status,
        err,
        data,
    };
}
function _getLicense(status, err, data) {
    return {
        type: GET_LICENSE,
        status,
        err,
        data,
    };
}
function _initialPasswordUpdate(status, err, data) {
    return {
        type: INITIAL_PASSWORD_UPDATE,
        status,
        err,
        data,
    };
}
function _register(status, err, data) {
    return {
        type: REGISTER,
        status,
        err,
        data,
    };
}

const _updateUserLicense = (status, data, err) => {
    return {
        type: UPDATE_USER_LICENSE,
        data,
        err,
        status,
    };
};

const _updatesso = (status, data, err) => {
    return {
        type: UPDATE_SSO,
        data,
        err,
        status,
    }
}

function _asignCoupon(status, err, data) {
    return {
        type: ASIGN_COUPON,
        status,
        err,
        data,
    };
}

export const preprocessLoginDetails = (firstField, passwordField) => {
    let processedFirstField = _.chain(firstField)
        .trim()
        .value();
    const processedPasswordField = _.chain(passwordField)
        .split(" ")
        .join("")
        .value();

    return {
        processedFirstField,
        processedPasswordField,
    };
};

export const validateLoginDetails = (firstField, firstFieldType) => {
    let errorMessage = null;
    if (
        firstFieldType &&
        firstFieldType === "email" &&
        !_.includes(firstField, "@")
    ) {
        errorMessage =
            "Email is invalid format, please check the email you have entered.";
    }
    return errorMessage;
};

function login(firstField, password, apiURL) {
    return (dispatch, getState, Request) => {
        let loginDetails = preprocessLoginDetails(firstField, password);
        const validateLoginDetail = validateLoginDetails(
            firstField,
            "username"
        );
        if (!validateLoginDetail) {
            let loginCredentials = {
                username: loginDetails.processedFirstField,
                password: loginDetails.processedPasswordField,
            };
            let ciphertext = {
                authToken: CryptoJS.AES.encrypt(
                    JSON.stringify(loginCredentials),
                    appConfig.secret ? appConfig.secret : "16t17t5m"
                ).toString(),
            };
            const loginPath = appConfig.endpoints.emailSignInPath;
            return Request.fetch(
                loginPath,
                {
                    method: "POST",
                    body: ciphertext,
                },
                apiURL
            )
                .then((response) => {
                    return response.json();
                })
                .then((userData) => {
                    return dispatch(
                        _login("success", null, {
                            id: userData._id,
                            email: userData.email,
                            uid: userData._id,
                            provider: "MANUAL",
                            username: userData.username,
                            first_name: userData.first_name,
                            last_name: userData.last_name,
                            user_active: userData.active,
                            lang: userData.lang,
                            isUserLoggedIn: true,
                            license: userData.license,
                            details: userData.details,
                            client: {
                                appConfiguration: userData.branding,
                            },
                            initialUpdatePassword:
                                userData.initialUpdatePassword,
                            courses: userData.courses,
                        })
                    );
                })
                .catch((err) => {
                    dispatch(_login("error", err, null));
                    return Promise.reject(err);
                });
        } else {
            return Promise.resolve({
                status: 500,
                errors: [validateLoginDetail],
            });
        }
    };
}

function tokenLogin(token, sso) {
    return (dispatch, getState, Request) => {
        const loginPath = appConfig.endpoints.tokenSignInPath;
        return Request.fetch(loginPath, {
            method: "POST",
            headers: {
                authtoken: token,
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return dispatch(
                    _login("success", null, {
                        id: userData.user._id,
                        email: userData.user.email,
                        uid: userData.user._id,
                        provider: "MANUAL",
                        username: userData.user.username,
                        first_name: userData.user.first_name,
                        last_name: userData.user.last_name,
                        user_active: userData.user.active,
                        lang: userData.user.lang,
                        isUserLoggedIn: true,
                        license: userData.user.license,
                        details: userData.user.details,
                        client: {
                            appConfiguration: userData.user.branding,
                        },
                        courses: userData.user.courses,
                        guestCourse: userData.course,
                        initialUpdatePassword: userData.user.initialUpdatePassword,
                        isRegisterLogin: sso
                    })
                );
            })
            .catch((err) => {
                dispatch(_login("error", err, null));
                return Promise.reject(err);
            });
    };
}

function forgotPassword(email) {
    return (dispatch, getState, Request) => {
        const passwChangePath = appConfig.endpoints.emailForgotPasswordPath;
        return Request.fetch(passwChangePath, {
            method: "POST",
            body: JSON.stringify({
                email: _.chain(email)
                    .trim()
                    .toLower()
                    .value(),
            }),
        })
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function logout() {
    return (dispatch, getState, Request) => {
        dispatch(_logout("fetching"));
        const logoutPath = appConfig.endpoints.signOutPath;
        return Request.fetch(logoutPath, {
            method: "POST",
            body: "",
        })
            .then(() => {
                Request.resetToken();
            })
            .then(() => {
                return dispatch(_logout("success"));
            })
            .catch((err) => {
                // If some errors still log him out of application
                Request.resetToken();
                return dispatch(_logout("error", err));
            });
    };
}

function session() {
    return (dispatch, getState, Request) => {
        return Promise.resolve(dispatch(_session()));
    };
}

function omniAuthLogin(userDetail) {
    return (dispatch, getState, Request) => {
        const accessToken = userDetail["access_token"];
        Request.setToken(
            accessToken["access-token"],
            accessToken.client,
            accessToken.expiry,
            accessToken["token-type"],
            accessToken.uid
        );
        return Promise.resolve(
            dispatch(
                _omniauthLogin(
                    "success",
                    null,
                    _.omit(userDetail, "access-token")
                )
            )
        );
    };
}

function updateConfig(configHash) {
    return (dispatch, getState, Request) => {
        const updateConfigPath = appConfig.endpoints.updateConfigPath.replace(
            ":id",
            getState().auth.user.client.id
        );
        return Promise.resolve(
            dispatch(
                _updateConfig("success", null, {
                    partConfig: configHash,
                })
            )
        ).then(() => {
            return Request.fetch(updateConfigPath, {
                method: "PATCH",
                body: JSON.stringify({
                    client: {
                        name: getState().auth.user.client.name,
                        app_configuration: configHash,
                    },
                }),
            })
                .then((response) => {
                    return response.json();
                })
                .then((resp) => { })
                .catch((err) => {
                    console.log(err);
                });
        });
    };
}

const createOrder = (plan) => {
    return (dispatch, getState, Request) => {
        let createOrderPath = appConfig.endpoints.createOrderPath.replace(
            ":id",
            plan
        );
        return Request.fetch(createOrderPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const createSubscription = (plan) => {
    return (dispatch, getState, Request) => {
        let createSubscriptionPath = appConfig.endpoints.createSubscriptionPath.replace(
            ":id",
            licenseMap[plan].planId
        );
        return Request.fetch(createSubscriptionPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const verifySubscription = (responseHash) => {
    return (dispatch, getState, Request) => {
        let verifySubscriptionPath = appConfig.endpoints.verifySubscriptionPath;
        return Request.fetch(verifySubscriptionPath, {
            method: "POST",
            body: JSON.stringify(responseHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return dispatch(
                    _updateUserLicense(
                        "success",
                        {
                            license: response.license,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const verifyOrder = (responseHash) => {
    return (dispatch, getState, Request) => {
        let verifyOrderPath = appConfig.endpoints.verifyOrderPath;
        return Request.fetch(verifyOrderPath, {
            method: "POST",
            body: JSON.stringify(responseHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return dispatch(
                    _updateUserLicense(
                        "success",
                        {
                            license: response.license,
                        },
                        null
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const fetchInvoices = (subscriptionId) => {
    return (dispatch, getState, Request) => {
        let getInvoicesPath = appConfig.endpoints.getInvoicesPath.replace(
            ":id",
            subscriptionId
        );
        return Request.fetch(getInvoicesPath, {
            method: "GET",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const sendContactUsRequst = (name, phonenumber, workemail, message) => {
    return (dispatch, getState, Request) => {
        const contactUsRequestPath = appConfig.endpoints.contactUsRequestPath;
        return Request.fetch(contactUsRequestPath, {
            method: "POST",
            body: JSON.stringify({
                name: name,
                phonenumber: phonenumber,
                workemail: workemail,
                message: message,
                subject: "Requesting for upgrade to the Enterprise Plan",
            }),
        })
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

function getLicense() {
    return (dispatch, getState, Request) => {
        const getLicensePath = appConfig.endpoints.getLicensePath.replace(
            ":id",
            getState().auth.user.license.id
        );

        return Request.fetch(getLicensePath)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(
                    dispatch(
                        _getLicense("success", null, {
                            license: data,
                        })
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
}

function initialPasswordUpdate(userId, new_password) {
    return (dispatch, getState, Request) => {
        let formData = new FormData();
        formData.append("password", new_password);
        formData.append("password_confirmation", new_password);
        const initialUpdatePasswordPath = appConfig.endpoints.initialUpdatePasswordPath.replace(
            ":id",
            userId
        );
        return Request.fetch(initialUpdatePasswordPath, {
            method: "POST",
            body: formData,
        })
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return dispatch(
                    _initialPasswordUpdate("success", null, {
                        initialUpdatePassword: userData.initialUpdatePassword,
                    })
                );
            })
            .catch((err) => {
                dispatch(_updateConfig("error", err, null));
                return Promise.reject(err);
            });
    };
}

function registerFreeInductor(
    name,
    username,
    email,
    password,
    manager,
    details,
    license
) {
    return (dispatch, getState, Request) => {
        const emailRegistrationPath = appConfig.endpoints.registerUserPath;
        let hasError = false;
        let errorText = "";
        if (!appConfig.registration.creatorAllowed) {
            hasError = true;
            errorText = "You are not allowed to self register on the platform";
        }
        let nameSplit = name.split(" ");

        if (hasError) {
            return Promise.reject(
                dispatch(
                    _register(
                        "error",
                        {
                            message: [errorText],
                            response: {
                                status: "error",
                                err: {
                                    errors: {
                                        full_messages: [errorText],
                                    },
                                },
                            },
                        },
                        null
                    )
                )
            );
        } else {
            return (
                Request.fetch(emailRegistrationPath, {
                    method: "POST",
                    body: JSON.stringify({
                        username: username,
                        password: password,
                        email: email,
                        manager: manager,
                        first_name: _.startCase(_.toLower(nameSplit[0])),
                        last_name:
                            nameSplit[1] === undefined
                                ? " "
                                : _.startCase(_.toLower(nameSplit[1])),
                        details: details,
                        license: license
                    }),
                })
                    .then((response) => {
                        return response.json();
                    })
                    // .then((regData) => {
                    //     let formData = new FormData();
                    //     formData.append("username", username);
                    //     formData.append("password", password);
                    //     const loginPath = appConfig.endpoints.emailSignInPath;
                    //     return Request.fetch(loginPath, {
                    //         method: "POST",
                    //         body: formData,
                    //     })
                    //         .then((response) => {
                    //             return response.json();
                    //         })
                    //         .then((userData) => {
                    //             return dispatch(
                    //                 _register("success", null, {
                    //                     id: userData._id,
                    //                     email: userData.email,
                    //                     uid: userData._id,
                    //                     provider: "MANUAL",
                    //                     username: userData.username,
                    //                     first_name: userData.first_name,
                    //                     last_name: userData.last_name,
                    //                     user_active: userData.active,
                    //                     isUserLoggedIn: true,
                    //                     license: userData.license,
                    //                     details: userData.details,
                    //                     client: {
                    //                         appConfiguration: userData.branding,
                    //                     },
                    //                     initialUpdatePassword: userData.initialUpdatePassword,
                    //                     courses: userData.courses
                    //                 })
                    //             );
                    //         });
                    // })
                    .catch((err) => {
                        return dispatch(_register("error", { err: err }, null));
                    })
            );
        }
    };
}

const checkUsername = (username) => {
    return (dispatch, getState, Request) => {
        if (username.split(" ").length > 1)
            return Promise.resolve({ valid: false });
        else
            return Request.fetch(`/api/v3/utility/check/${username}`)
                .then((response) => {
                    return response.json().then((data) => {
                        return Promise.resolve(data);
                    });
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
    };
};

function ssoRegister() {
    return (dispatch, getState, Request) => {
        return dispatch(
            _updatesso("success", {
                isRegisterLogin: false
            }, null)
        )
    };
}

const checkCouponcode = (code) => {
    return (dispatch, getState, Request) => {
        let checkCuponPath = appConfig.endpoints.checkCuponPath.replace(':code', code);
        return Request.fetch(checkCuponPath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

function asignCoupon(
    coupons,
    userId
) {
    return (dispatch, getState, Request) => {
        const asignCouponPath = appConfig.endpoints.assignCouponPath.replace(":id", userId);
        return (
            Request.fetch(asignCouponPath, {
                method: "POST",
                body: JSON.stringify({
                    coupons: coupons,
                    provider: "appSumo"
                })
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    return dispatch(
                        _asignCoupon(
                            "success",
                            null,
                            response
                        )
                    );
                })
                .catch((err) => {
                    return dispatch(_asignCoupon("error", { err: err }, null));
                })
        );

    };
}

class AuthenticationAction {
    static login = login;
    static logout = logout;
    static session = session;
    static forgotPassword = forgotPassword;
    static omniAuthLogin = omniAuthLogin;
    static tokenLogin = tokenLogin;
    static updateConfig = updateConfig;
    static getLicense = getLicense;
    static createOrder = createOrder;
    static createSubscription = createSubscription;
    static verifySubscription = verifySubscription;
    static verifyOrder = verifyOrder;
    static fetchInvoices = fetchInvoices;
    static sendContactUsRequst = sendContactUsRequst;
    static initialPasswordUpdate = initialPasswordUpdate;
    static registerFreeInductor = registerFreeInductor;
    static checkUsername = checkUsername;
    static ssoRegister = ssoRegister;
    static checkCouponcode = checkCouponcode;
    static asignCoupon = asignCoupon;
}

export { AuthenticationAction };
